import endpoints from "../data/endpoints";
import { GeocodeResponse } from "../types/types";
import apiRequest from "./apiRequest";

export const geocodeZip = async (
	zipCode: string,
): Promise<GeocodeResponse["data"]> => {
	const response = (await apiRequest(endpoints.geocode.url, {
		method: endpoints.geocode.requestMethod,
		body: JSON.stringify({ zipCode }),
	})) as GeocodeResponse;

	return response.data;
};
